package com.tovtalk.ui.scaffold

import androidx.compose.material3.SnackbarHostState
import androidx.compose.runtime.compositionLocalOf

/**
 * [androidx.compose.runtime.CompositionLocal] that provides the current screen's
 * [SnackbarHostState] to all descendants.
 *
 * Provided automatically by [ScreenScaffold]. Any composable inside a screen can call:
 *
 * ```kotlin
 * val snackbar = LocalSnackbarHost.current
 * val scope = rememberCoroutineScope()
 * scope.launch { snackbar.showSnackbar("saved") }
 * ```
 *
 * Reading this outside a [ScreenScaffold] throws — there is no sensible default because
 * a snackbar needs a host rendered somewhere in the tree.
 */
val LocalSnackbarHost = compositionLocalOf<SnackbarHostState> {
    error("LocalSnackbarHost not provided — wrap with ScreenScaffold")
}
